import { render } from "./Intro.vue?vue&type=template&id=44174562"
const script = {}

import "./Intro.vue?vue&type=style&index=0&id=44174562&lang=scss"
script.render = render

export default script